import { lazy } from 'react';

const StartSearch = lazy(() => import('@pages/start-search'));
const homeRoute = [
    {
        path: "/startSearch",
        name: '智慧搜索',
        component: StartSearch
    }
]
export default homeRoute